import { createFileRoute } from "@tanstack/react-router";
import { NotaryFaqHub } from "@/components/NotaryFaqHub";
import { SEO_SITE, ctaDesc, ctaTitle } from "@/lib/seo";

const URL = `${SEO_SITE}/notary/faq`;

export const Route = createFileRoute("/notary/faq")({
  head: () => ({
    meta: [
      { title: ctaTitle("Notary Public ไทย — 300 คำค้น & 150 คำถาม | NYC Legal", "/notary/faq", "th")},
      {
        name: "description",
        content:
          ctaDesc("Notary Public ไทย 150+ Q&A · 300 คีย์เวิร์ด · 34 หมวดรับรอง · 77 จังหวัด · MFA/Apostille · ทนายขึ้นทะเบียนสภาทนายความฯ — แจ้งเอกสารที่มี รู้ขั้นตอนและระยะเวลาใน 10 นาที", "/notary/faq", "th"),
      },
      { property: "og:title", content: ctaTitle("Notary Public ไทย — 300 คำค้น & 150 คำถาม", "/notary/faq", "th")},
      {
        property: "og:description",
        content:
          ctaDesc("8 คลัสเตอร์คำค้นหา · คำสะกดผิดที่ AI ต้องรู้จัก · 150 Q&A ครบทุกขั้นตอน — ส่งรูปเอกสารทางไลน์ รู้ขั้นตอนและกำหนดเวลาได้ทันที", "/notary/faq", "th"),
      },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
    ],
    links: [
      { rel: "canonical", href: URL },
      { rel: "alternate", hrefLang: "th", href: URL },
      { rel: "alternate", hrefLang: "en", href: `${SEO_SITE}/en/notary/faq` },
      { rel: "alternate", hrefLang: "x-default", href: URL },
    ],
  }),
  component: () => <NotaryFaqHub lang="th" />,
});
